import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 style={{
      "marginBottom": "4rem"
    }}>Hi there, I'm Phat Pham 👋</h2>
    <p>{`I've spent 13 years building software as a full-stack developer, solution architect, and entrepreneur, taking products from early ideas to production.`}</p>
    <p>{`My background is in Software Engineering and Computer Science, and along the way I've founded two startups. My current interests sit at the intersection of cloud native architecture, microservices/serverless, and AI/ML.`}</p>
    <p>{`You can find my work on GitHub `}<a parentName="p" {...{
        "href": "https://github.com/phatpham9"
      }}>{`/phatpham9`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/boringcode-dev"
      }}>{`/boringcode-dev`}</a>{` and Hugging Face `}<a parentName="p" {...{
        "href": "https://huggingface.co/phatpham9"
      }}>{`/phatpham9`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      